<script>
  import DropDown from '../DropDown.svelte';
  import CreateGroup from './CreateGroup.svelte';
  import TaskGroup from './TaskGroup.svelte';
  import TaskReport from './TaskReport.svelte';
  import { client } from 'root/api/index.js';
  import DatePicker from '../Flatpickr/DatePicker.svelte';
  import { Modal } from 'bootstrap';
  import {
    downloadCsvFile,
    searchKeyByValue,
    configItem,
    dbDateFormat,
  } from 'components/Helper.js';
  import { getContext, createEventDispatcher } from 'svelte';

  export let unitUsers;
  export let clientUnitUsers;
  export let dashboardLeftObj;
  export let type;
  let editButtonClick = false;
  let showSaveGroup = false;
  const checkSave = () => {
    showSaveGroup = unitUsers.filter((item) => item.checked == true).length > 0;
  };
  $: unitUsers && checkSave();
  import { dashboardData, getDashboardData, setDashboardData } from '../../stores/dashboard.js';
  import ReportFilter from './ReportFilter.svelte';

  export let setDashboardFilter;
  export let extraFilter;
  export let changeFilter;

  export let fromToRange = '';
  export let initialFromToRange = '';
  export let showSaveButton = false;
  export let filter = {};
  export let selectedFilterData = {};
  const dispatch = createEventDispatcher();

  // export let filterReportType="";
  let selectedFilter = '';
  let editFilterdData = {};
  export let filterSelected = false;
  const resetFromToRange = () => {
    if (extraFilter.fromDate == '') {
      fromToRange = '';
    } else {
      fromToRange = extraFilter.fromDate + ' to ' + extraFilter.toDate;
    }
    // Reseting initial board date from and to
    if (extraFilter.initialFromDate == '') {
      initialFromToRange = '';
    } else {
      initialFromToRange = extraFilter.initialFromDate + ' to ' + extraFilter.initialToDate;
    }
    // clientUnitUsers = clientUnitUsers.map(item=>{
    //   item.checked=searchKeyByValue(extraFilter.clients,"id",item.id)!=-1
    //   return item;
    // });
    // unitUsers = unitUsers.map(item=>{
    //   item.checked=searchKeyByValue(extraFilter.users,"id",item.id)!=-1
    //   return item;
    // });
  };
  $: extraFilter && resetFromToRange();
  let createGroupModal;
  let groupUsers = [];
  const saveGroup = () => {
    groupUsers = extraFilter.users;
    createGroupModal = new Modal(document.getElementById('creatGroupModal'), {
      keyboard: false,
    });
    createGroupModal.show();
  };
  let taskGroupModal;
  let createFilterGroupModal;
  const showGroup = () => {
    taskGroupModal.show();
  };

  let taskReportModal;
  const showReport = () => {
    taskReportModal.show();
  };

  const showDialog = getContext('showDialog');
  export let showDate = false;
  let datePickerRef;
  let initialDatePickerRef;
</script>

<DropDown
  removeIcon={true}
  checkbox={true}
  searchbox={true}
  active={false}
  title="Assignee"
  option={unitUsers}
  Style="select-block assignee-filter-drop"
  checkedFields="checked"
  on:onClear={(event) => {
    extraFilter.users = [];
    showSaveGroup = false;
    setDashboardFilter('task', extraFilter);
    changeFilter(extraFilter);
    setTimeout(() => {
      setDashboardData({
        ...getDashboardData(),
        users: extraFilter.users,
      });
    }, 1000);
  }}
  on:onSelect={(event) => {
    extraFilter.users = event.detail.map((item) => {
      item.id = item.userId;
      return item;
    });
    showSaveGroup = event.detail.length > 0;
    setDashboardFilter('task', extraFilter);
    changeFilter(extraFilter);
    setTimeout(() => {
      setDashboardData({
        ...getDashboardData(),
        users: extraFilter.users,
      });
    }, 1000);
  }}
/>

{#if showSaveGroup == true}
  <button
    type="button"
    class="task-filter-icon ms-0 btn-primary border-0 px-2 rounded ms-2 font-size-13 text-nowrap"
    on:click={() => {
      saveGroup();
      setTimeout(() => {
        createFilterGroupModal.show(unitUsers, {
          userId: '',
          id: '',
          readonly: '',
          name: '',
          users: groupUsers,
        });
      }, 100);
    }}
  >
    Save Group
  </button>
{/if}
<button
  type="button"
  class="task-filter-icon btn btn-primary border-0 px-2 rounded ms-2 text-nowrap font-size-13"
  on:click={showGroup}
>
  <!-- View Groups -->
  My Groups
</button>

<div class="customer-group-picker ms-2 me-1 d-flex flex-row align-items-center">
  <div class="customer-picker">
    <DropDown
      removeIcon={true}
      on:onClear={(event) => {
        extraFilter.clients = [];
        changeFilter(extraFilter);
        setTimeout(() => {
          setDashboardData({
            ...getDashboardData(),
            clients: [],
          });
        }, 1000);
      }}
      checkbox={true}
      searchbox={true}
      active={false}
      title="Client"
      option={clientUnitUsers}
      Style="select-block client-filter-dropdown"
      checkedFields="checked"
      on:onSelect={(event) => {
        extraFilter.clients = event.detail;
        changeFilter(extraFilter);
        setTimeout(() => {
          setDashboardData({
            ...getDashboardData(),
            clients: event.detail,
          });
        }, 1000);
      }}
    />
  </div>
  <!-- <button
					on:click={()=>{
					  dashboardLeftObj.viewAll(extraFilter.clients)
					}}
					type="button"
					class="btn btn-link color-blue mb-0 font-size-12 p-0 shadow-none border-0 bg-transparent "><svg fill="#206bc4" class="mx-1 svelte-dhog5f" width="14" height="14" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><path d="M8.04898 8.28698L14.299 1.99997L10.709 1.99997L10.709 -2.41836e-05L17.709 -2.47955e-05L17.709 6.99997L15.709 6.99997L15.709 3.41997L9.46399 9.69898L8.04898 8.28698Z" fill="#206bc4"></path><path d="M8 1.70599V3.70599H2V15.706H14V9.70599H16V17.706H0V1.70599H8V1.70599Z" fill="#206bc4"></path></svg>
					View All</button> -->
</div>

{#if showDate && dashboardLeftObj != undefined && dashboardLeftObj.getTabIndex() == 1 && extraFilter.comeFrom != 'calender'}
  <div class="d-flex flex-row justify-content-between">
    <div
      class="date-picker date-range-picker"
      style="position: relative;"
    >
      <DatePicker
        mode="range"
        showMonths="2"
        bind:this={datePickerRef}
        placeholder="Select Due Date(s)"
        value={fromToRange}
        on:close={(value) => {
          let event = value.detail[0];
          if (event.length == 1) {
            event = [];
            fromToRange = value.detail[1];
            extraFilter.fromDate = event[0] != undefined ? dbDateFormat(event[0]) : '';
            extraFilter.toDate = event[1] != undefined ? dbDateFormat(event[1]) : '';
            changeFilter(extraFilter);
            setDashboardData({
              ...getDashboardData(),
              fromDate: event[0] != undefined ? dbDateFormat(event[0]) : '',
              toDate: event[1] != undefined ? dbDateFormat(event[1]) : '',
            });
          }
        }}
        on:change={(value) => {
          let event = value.detail[0];
          if (event.length == 1) {
            return false;
          }
          fromToRange = value.detail[1];
          extraFilter.fromDate = event[0] != undefined ? dbDateFormat(event[0]) : '';
          extraFilter.toDate = event[1] != undefined ? dbDateFormat(event[1]) : '';
          changeFilter(extraFilter);
          setDashboardData({
            ...getDashboardData(),
            fromDate: event[0] != undefined ? dbDateFormat(event[0]) : '',
            toDate: event[1] != undefined ? dbDateFormat(event[1]) : '',
          });
        }}
      />
      {#if extraFilter.fromDate != '' || extraFilter.toDate != ''}
        <button
          class="remove-btn bg-transparent border-0"
          on:click={() => {
            datePickerRef.clear();
          }}
        >
          <img
            alt=""
            src="/images/close.svg"
          />
        </button>
      {/if}
    </div>
  </div>

  <!-- Initial Board Date filter -->
  <div class="d-flex flex-row justify-content-between">
    <div
      class="date-picker date-range-picker"
      style="position: relative;"
    >
      <DatePicker
        mode="range"
        showMonths="2"
        bind:this={initialDatePickerRef}
        placeholder="Select Initial Board Date(s)"
        value={initialFromToRange}
        on:close={(value) => {
          let event = value.detail[0];
          if (event.length == 1) {
            event = [];
            initialFromToRange = value.detail[1];
            extraFilter.initialFromDate = event[0] != undefined ? dbDateFormat(event[0]) : '';
            extraFilter.initialToDate = event[1] != undefined ? dbDateFormat(event[1]) : '';
            changeFilter(extraFilter);
            setDashboardData({
              ...getDashboardData(),
              initialFromDate: event[0] != undefined ? dbDateFormat(event[0]) : '',
              initialToDate: event[1] != undefined ? dbDateFormat(event[1]) : '',
            });
          }
        }}
        on:change={(value) => {
          let event = value.detail[0];
          if (event.length == 1) {
            return false;
          }
          initialFromToRange = value.detail[1];
          extraFilter.initialFromDate = event[0] != undefined ? dbDateFormat(event[0]) : '';
          extraFilter.initialToDate = event[1] != undefined ? dbDateFormat(event[1]) : '';
          changeFilter(extraFilter);
          setDashboardData({
            ...getDashboardData(),
            initialFromDate: event[0] != undefined ? dbDateFormat(event[0]) : '',
            initialToDate: event[1] != undefined ? dbDateFormat(event[1]) : '',
          });
        }}
      />
      {#if extraFilter.initialFromDate != '' || extraFilter.initialToDate != ''}
        <button
          class="remove-btn bg-transparent border-0"
          on:click={() => {
            initialDatePickerRef.clear();
          }}
        >
          <img
            alt=""
            src="/images/close.svg"
          />
        </button>
      {/if}
    </div>
  </div>
{/if}

<button
  type="button"
  class="task-filter-icon btn btn-primary border-0 px-2 rounded ms-2 text-nowrap font-size-13"
  on:click={showReport}
>
  My Reports
</button>
<ReportFilter
  showSaveButton={showSaveButton}
  filter={filter}
  type={type}
  filterSelected={filterSelected}
  editButton={editButtonClick}
  filterId={filterSelected == true && editButtonClick != true
    ? selectedFilterData.id
    : editButtonClick == true
      ? editFilterdData.id
      : 0}
  on:onSave={(item) => {
    showSaveButton = false;
    editButtonClick = false;
    client
      .taskFilterReportGet({ id: item.detail.id })
      .then((response) => {
        dispatch('filterSelected', response.data);
        filterSelected = true;
        selectedFilter = response.data.name;
        selectedFilterData = response.data;
      })
      .catch((err) => {
        showDialog({ type: 'warning', message: [err] });
      });
    dispatch('filterSave', showSaveButton);
  }}
  on:hide={(item) => {
    editButtonClick = false;
  }}
/>
<div class="task-filter-icon px-2 pt-2 ms-2 text-nowrap font-size-13">
  {#if filterSelected}
    <span
      class="clone_popup"
      data-bs-placement="top"
      data-bs-toggle="popover"
      data-bs-trigger="hover focus"
      data-bs-content={selectedFilter}
    >
      Selected Report: {selectedFilter}
    </span>
    <button
      class="btn btn-link p-0 font-size-12"
      on:click={() => {
        filterSelected = false;
        selectedFilter = '';
        dispatch('clearFilter');
      }}>clear</button
    >
  {/if}
</div>

<CreateGroup
  bind:this={createFilterGroupModal}
  groupUsers={groupUsers}
  saveGroup={(event) => {
    client
      .taskFilterGroupSave(event)
      .then(async (result) => {
        createGroupModal.hide();
        showSaveGroup = false;
      })
      .catch((err) => {
        showDialog({ message: [err.message] });
      });
  }}
/>
<TaskGroup
  bind:this={taskGroupModal}
  showGroup={(flag, event) => {
    if (flag == 'edit') {
      saveGroup();
      setTimeout(() => {
        createFilterGroupModal.show(event.unitUsers, {
          userId: '',
          userId: '',
          id: event.id,
          readonly: event.readonly,
          name: event.name,
          users: event.users,
        });
      }, 1000);
      return false;
    }

    let oldUnitUsers = unitUsers;
    oldUnitUsers.map((item) => (item.checked = false));
    extraFilter.users = event.users.map((item) => {
      item.userId = item.id;
      let dbKey = searchKeyByValue(oldUnitUsers, 'userId', item.userId);
      if (dbKey != -1) {
        oldUnitUsers[dbKey].checked = true;
      }
      return item;
    });
    unitUsers = oldUnitUsers;
    changeFilter(extraFilter);
  }}
/>

<TaskReport
  bind:this={taskReportModal}
  type={type}
  on:select={(item) => {
    dispatch('filterSelected', item.detail);
    filterSelected = true;
    editButtonClick = false;
    selectedFilter = item.detail.name;
    selectedFilterData = item.detail;
  }}
  on:edit={(item) => {
    editButtonClick = true;
    if (filterSelected == true) {
    }
    // selectedFilterData=item.detail
    editFilterdData = item.detail;
  }}
/>

<style lang="scss">
  .remove-btn {
    /*display: none;*/
    position: absolute;
    right: -3px;
    top: -4px;
    width: 17px;
    background: $lead-color !important;
    width: 16px;
    height: 16px !important;
    border-radius: 6px !important;
    line-height: 0px;
    padding: 0px;
    z-index: 1;

    img {
      width: 8px;
    }
    &:hover {
      background: $black-color !important;
    }
  }

  .customer-group-picker {
    margin-left: 37px;
    margin-right: 37px;
  }
  .task-filter-icon {
    img {
      width: 16px;
      height: 16px;
    }
  }
  .save-group {
    border-radius: 0 4px 4px 0;
  }
  .date-picker {
    width: 230px;
  }
</style>
